import { useCallback } from 'react'
import { Column, GridApi } from 'ag-grid-community'
import { intl } from '../../../../../i18n'
import DateVO from '../../../../../vo/DateVO'
import MultiSelectDialog, {
  MultiSelectDialogSelection,
} from '../../../../components/dialogs/MultiSelectDialog'
import { isWorkMonthColumnDef } from '../../gridOptions/common'

type Props = {
  onClose: () => void
  onSubmit: (colIds: string[]) => void
  gridApi?: GridApi | null
}

export const ExcelExportDialog = ({ onClose, onSubmit, gridApi }: Props) => {
  const getSelectionItemDisplayName = useCallback(
    (gridApi: GridApi | undefined, column: Column): string => {
      if (
        column.getParent()?.getColGroupDef() &&
        isWorkMonthColumnDef(column.getParent()!.getColGroupDef()!)
      ) {
        return new DateVO(column.getColId()).format(
          intl.formatMessage({ id: 'dateFormat.yyyy.mm' })
        )
      }
      if (!gridApi) return ''
      return gridApi?.getDisplayNameForColumn(column, null)
    },
    []
  )

  const getSelectionList = useCallback(
    (gridApi?: GridApi): MultiSelectDialogSelection[] => {
      return (gridApi?.getColumns() || [])
        .filter((column: Column) => !['drag'].includes(column.getColId()))
        .map((column: Column) => {
          return {
            value: column.getColId(),
            displayName: getSelectionItemDisplayName(gridApi, column),
            defaultChecked:
              column.isVisible() ||
              column.getColDef().cellRendererParams?.uiMeta?.tree,
          }
        }) as MultiSelectDialogSelection[]
    },
    [getSelectionItemDisplayName]
  )

  return (
    <MultiSelectDialog
      onClose={onClose}
      onSubmit={(allList, selectedItem) => {
        const selectedColIds = selectedItem.map(col => col.value)
        onSubmit(selectedColIds)
      }}
      dialogTitle={intl.formatMessage({
        id: 'dialog.exceloutput.columnselect.title',
      })}
      submitButtonTitle={intl.formatMessage({
        id: 'dialog.exceloutput.submit',
      })}
      allCheckBoxLabel={intl.formatMessage({
        id: 'dialog.exceloutput.columnselect.allcheckboxlabel',
      })}
      getSelectList={() => getSelectionList(gridApi ?? undefined)}
      hideIcon={true}
    />
  )
}
